"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remapEntries = void 0;
const remapEntries = (obj, onEntry) => Object.fromEntries(Object.entries(obj).map((entry) => onEntry(entry)).filter((x) => x !== null));
exports.remapEntries = remapEntries;
//# sourceMappingURL=remapEntries.js.map